import urlJoin from 'url-join';
import { connectedStore } from '../../store';
import getAssetsUrl from '../selectors/get-assets-url';

const composeAssetUrl = (source, options) => {
  const store = connectedStore.get();
  const state = store.getState();
  const assetsUrl = getAssetsUrl(state);

  return urlJoin(assetsUrl, source, options && options.encode ? '?encode=true' : '');
};

export default composeAssetUrl;
